module.exports = __webpack_public_path__ + "static/UX-promo-720p-1e92b9894cd586b501ae3d4724f46d9c.mp4";